import React from 'react';
import { Box } from '../element';
import { Menu } from 'grommet-icons';

const ResponsiveMenuIcon = props => {
  return (
    <Box pad={{ top: 'small' }}>
      <span style={{ cursor: 'pointer' }} onClick={props.onResponsiveMenuIconClick}>
        <Menu style={{ fontSize: '18px', color: '#444' }} />
      </span>
    </Box>
  );
};

export default ResponsiveMenuIcon;
